import React, { useContext, useState } from 'react'

import PanelHeader from '../../../elem/panel/PanelHeader'
import { DataContext } from './DataContext'
import TimeWindowSelectorButton from '../../../elem/chart/TimeWindowSelectorButton'
import ResetZoomButton from '../../../elem/chart/ResetZoomButton'
import SaveAsImageButton from '../../../elem/chart/SaveAsImageButton'
import { AppStateContext } from '../AppStateContext'
import CollapseButton from '../../../elem/list/CollapseButton'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import ExpandButton from '../../../elem/list/ExpandButton'

const AggregateHeader = ({ chartRef, isCollapsed, setCollapsed }) => {
    const {
        timeWindow,
        displayTimeWindowDropdown,
        toggleTimeWindowDropdown,
        loading,
        tooManyFeatures,
        resetZoom,
    } = useContext(DataContext)
    const {
        mapState: { selectedFeatures },
    } = useContext(AppStateContext)

    const { isExpanded, setIsExpanded } = useContext(PanelStyleContext)

    return (
        <PanelHeader extraClass={'aggregatePanelHeader'}>
            <div className="panelHeaderText">Aggregate Nitrate Chart</div>
            <div className="panelButtons">
                <SaveAsImageButton
                    name={'AggregateNitrateChart'}
                    componentRef={chartRef}
                    disabled={
                        loading || tooManyFeatures || !selectedFeatures.length
                    }
                />
                <ResetZoomButton resetFunction={resetZoom} />
                <TimeWindowSelectorButton
                    timeWindow={timeWindow}
                    displayTimeWindowDropdown={displayTimeWindowDropdown}
                    toggleTimeWindowDropdown={toggleTimeWindowDropdown}
                />
                <div className="panelHeaderIconWrapper">
                    {isExpanded ? null : (
                        <CollapseButton
                            name={`nitrate-aggregate`}
                            isCollapsed={isCollapsed}
                            setIsCollapsed={setCollapsed}
                        />
                    )}
                    <ExpandButton
                        name={`nitrate-aggregate`}
                        isExpanded={isExpanded}
                        setIsExpanded={setIsExpanded}
                    />
                </div>
            </div>
        </PanelHeader>
    )
}

export default AggregateHeader
